import { useRef, useState } from 'react';

import cn from 'classnames';

import { ChecksSelector } from 'components/ChecksSelector/ChecksSelector';
import { Button } from 'components/FormComponents/';
import { StepHeader } from 'components/StepHeader/StepHeader';

import styles from './Step2Form.module.scss';

export const Step2Form = ({ stepBack = () => {}, ...props }) => {
  const selectorRef = useRef(null);

  const [valid, setValid] = useState(false);

  return (
    <div className={cn(styles.root)}>
      <div className={cn('card', 'card-with-border')}>
        <StepHeader step={2} title="Select Check Types" subtitle="Choose the checks you need" />
        <div className={cn('background-secondary', 'u-padding', 'card_border--top')}>
          <ChecksSelector
            ref={selectorRef}
            {...props}
            setValidity={setValid}
            className="bg-neutral-2"
          />
        </div>
        <div className={cn('card_footer', 'u-flex-box', 'u-flex-justify-between')}>
          <Button onClick={stepBack} type="secondary">
            Back
          </Button>
          <Button
            onClick={() => selectorRef.current.submit()}
            disabled={!valid}
            dataTestId="launch-check-button">
            Launch Check
          </Button>
        </div>
      </div>
    </div>
  );
};
